// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__7EYBG","item":"style_item__jjsxC"};